export interface SurveyAddonShare {
    reports: boolean;
    answers: boolean;
    download: boolean;
    filters: boolean;
    cross: boolean;
    comparison?: boolean;
}

export const initialSurveyAddonShare: Readonly<SurveyAddonShare> = {
    reports: false,
    answers: false,
    download: false,
    filters: false,
    cross: false,
    comparison: false,
};
